var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReporte"),
      _vm._v(" "),
      _c("VerReporteProgramacion"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs9: "" } },
                    [
                      _c("v-icon", [_vm._v("bussines")]),
                      _vm._v("\n          Reporte de vacación\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha inicio",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_inicio,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_inicio", $$v)
                                      },
                                      expression: "form.fecha_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha fin",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_fin,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_fin", $$v)
                                      },
                                      expression: "form.fecha_fin"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.unidades_generales,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad general",
                                      maxlength: "50"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_general,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_general",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_general"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.unidades_especificas,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad especifica",
                                      maxlength: "50"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_especifica,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_especifica",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_especifica"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Paterno" },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.paterno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "paterno", $$v)
                                      },
                                      expression: "form.paterno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Materno" },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.materno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "materno", $$v)
                                      },
                                      expression: "form.materno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Nombres" },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.nombres,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nombres", $$v)
                                      },
                                      expression: "form.nombres"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Cédula de identidad" },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ci,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "ci", $$v)
                                      },
                                      expression: "form.ci"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Item" },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.item,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "item", $$v)
                                      },
                                      expression: "form.item"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.bandera_boton_buscar,
                                color: "rgba(31,14,180,0.3)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.obtenerListaFuncionarios(
                                    _vm.form.fecha_inicio,
                                    _vm.form.fecha_fin
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("\n              Buscar\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "rgba(158,11,127,0.6)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.limpiarCampos()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("redo")]),
                              _vm._v("\n              Limpiar\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.bandera_boton_buscar,
                                color: "rgba(50,150,40,0.7)",
                                title: "Ver reporte ",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.verReporte(_vm.form, 6)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("picture_as_pdf")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.bandera_boton_buscar,
                                color: "rgba(50,150,40,0.7)",
                                title: "Ver reporte de Saldos ",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.verReporteSaldos(_vm.form, 15)
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("picture_as_pdf")]),
                              _vm._v(
                                "\n              REPORTE DE SALDOS\n            "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: { headers: _vm.headers, items: _vm.lista_funcionarios },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.uni) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(props.item.fecha_incor)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nom) +
                              " " +
                              _vm._s(props.item.pat) +
                              " " +
                              _vm._s(props.item.mat) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.item) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_doc) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.cargo) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.saldo) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#f1b3f6",
                                  icon: "",
                                  title: "Ver reporte de vacaciones"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.verReporte(props.item, 10)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("picture_as_pdf")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "rgb(73,26,230)",
                                  icon: "",
                                  dark: "",
                                  title:
                                    "Ver reporte de cronograma de vacaciones"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.verReporteProgramacion(
                                      props.item
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("picture_as_pdf")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dafa02c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dafa02c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/CronogramaVacaciones2.vue
// module id = null
// module chunks = 